import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FlexGrid, FlexGridColumn, FlexGridCellTemplate } from '@grapecity/wijmo.react.grid';
import settings from '../../config/setting';
import { Spin, Space, Row, Col, Modal, Button, notification } from 'antd';
import moment from 'moment';
import { FlexGridFilter } from '@grapecity/wijmo.react.grid.filter';
import '@grapecity/wijmo.styles/wijmo.css';
import LeftBone from './../../assets/img/leftBone.png';
import LeftBoneUp from './../../assets/img/leftBoneUp.png';
import LeftMaskedBoneUp from './../../assets/img/leftMaskedBoneUp.png';
import LeftMaskedAirDown from './../../assets/img/leftzMaskedAirDown.png';
import LeftMaskedAirUp from './../../assets/img/leftMaskedAirUp.png';
import RightAir from './../../assets/img/rightAir.png';
import RightMaskedAirDown from './../../assets/img/rightMaskedAirDown.png';
import RightMaskedBoneUp from './../../assets/img/rightMaskedBoneUp.png';
import LeftAirDown from './../../assets/img/leftAirDown.png';
import LeftAirUp from './../../assets/img/leftAirUp.png';
import LeftCurrent from './../../assets/img/leftCurrent.png';
import RightAirDown from './../../assets/img/rightAirDown.png';
import RightBoneDown from './../../assets/img/rightBoneDown.png';
import RightBoneUp from './../../assets/img/rightBoneUp.png';
import RightCurrent from './../../assets/img/rightCurrent.png';
import RightMaskedAirUp from './../../assets/img/rightMaskedAirUp.png';
import RightMaskedBoneDown from './../../assets/img/rightMaskedBoneDown.png';
import LeftMaskedBoneDown from './../../assets/img/leftMaskedBoneDown.png';
import BaselineEstab from './../../assets/img/baselineEstab.png';
import { CollectionView } from '@grapecity/wijmo';
import { FilePdfTwoTone } from '@ant-design/icons';
import Plot from 'react-plotly.js';
import { FolderOpenTwoTone } from '@ant-design/icons/lib';


let flexes = '';
let showGrid = '';

const LeftEarTestForm = ({ id,setLeftEarResult,leftEarResult,RightEarResult }) => {
  const [audiogramRightData, setAudiogramRightData] = useState([]);
  const [rightNofound, setRightNoFound] = useState(false);
  const [rightView, setRightView] = useState();
  const [noGfound, setNoGFound] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const [listboxColumns, setListboxColumns] = useState([]);
  const [infoVisible, setInfoVisible] = useState(false);
  const [infoRecord, setInfoRecord] = useState([]);
  const [latestLeftEarRecord, setLatestLeftEarRecord] = useState(null);
  const [latestLeftBaslineRecord, setLatestLeftBaslineRecord] = useState(null);
  const [latestRightEarRecord, setLatestRightEarRecord] = useState(null);
  const [latestRightBaslineRecord, setLatestRightBaslineRecord] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDocItem, setSelectedDocItem] = useState([]);
  const[downloadLoadAttachName,setDownloadLoadAttachName]=useState([])
  const [docPermission, setDocPermission] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const theGrid = useRef();
  const theSearch = useRef();

  const filterRefCounter = useRef();

     const handleSessionExpired = () => {
      notification.open({
        message: 'Odoo session expired',
        description: 'Please login again.',
      });
    
      localStorage.clear();
      history.push('/public/sign-in');
    };

    const getLatestByLeftTestingDate = (data) => {
    if (!data || data.length === 0) return null;

    return data.reduce((latest, current) => {
      const latestDate = new Date(latest.testing_date);
      const currentDate = new Date(current.testing_date);
      return currentDate > latestDate ? current : latest;
    });
    };

      const getLatestByRightTestingDate = (data) => {
    if (!data || data.length === 0) return null;

    return data.reduce((latest, current) => {
      const latestDate = new Date(latest.testing_date);
      const currentDate = new Date(current.testing_date);
      return currentDate > latestDate ? current : latest;
    });
    };

  const getLatestLeftBaseline = (data) => {
    if (!data || data.length === 0) return null;
  
    // Filter out valid is_left_baseline records
    const filteredRecords = data.filter(
      (item) => item.is_left_baseline !== null && item.is_left_baseline !== false
    );
  
    // Return the latest one based on testing_date or created_date
    const latest = filteredRecords.reduce((latest, current) => {
      const latestDate = new Date(latest.testing_date || latest.created_date);
      const currentDate = new Date(current.testing_date || current.created_date);
      return currentDate > latestDate ? current : latest;
    }, filteredRecords[0]);
    return latest;
  };
  const getLatestRightBaseline = (data) => {
    if (!data || data.length === 0) return null;
  
    // Filter out valid is_left_baseline records
    const filteredRecords = data.filter(
      (item) => item.is_left_baseline !== null && item.is_left_baseline !== false
    );
    // Return the latest one based on testing_date or created_date
    const latest = filteredRecords.reduce((latest, current) => {
      const latestDate = new Date(latest.testing_date || latest.created_date);
      const currentDate = new Date(current.testing_date || current.created_date);
      return currentDate > latestDate ? current : latest;
    }, filteredRecords[0]);
    return latest;
  };
    useEffect(() => {
      if (RightEarResult && Array.isArray(RightEarResult)) {
        const latest = getLatestByRightTestingDate(RightEarResult);
        setLatestRightEarRecord(latest);
      }
      if (RightEarResult && Array.isArray(RightEarResult)) {
       const latest = getLatestRightBaseline(RightEarResult);
       setLatestRightBaslineRecord(latest)
      }
    }, [RightEarResult]);
  
    useEffect(() => {
      if (leftEarResult && Array.isArray(leftEarResult)) {
        const latest = getLatestByLeftTestingDate(leftEarResult);
        setLatestLeftEarRecord(latest);
      }
      if (leftEarResult && Array.isArray(leftEarResult)) {
       const latest = getLatestLeftBaseline(leftEarResult);
       setLatestLeftBaslineRecord(latest)
      }
    }, [leftEarResult]);

  useEffect(() => {
    if (location && location.state) {
      let props = location.state;
      // console.log('propsaudiogramlist===::: in form', props);
      getAudiogramRightHisData(location.state.emp_selected);
      getDocPermission()
    } else {
      history.goBack();
    }
  }, []);

  let theGrids = theGrid.current;
  let theSearchs = theSearch.current;
  if (theGrids && theSearchs) {
    theSearchs.control.grid = theGrids.control;
  }
  const gridInitialized = (ctl) => {
    ctl.select(-1, -1);
    showGrid = ctl;
    flexes = ctl;
    setListboxColumns(ctl.columns);
    const sender = ctl;
    sender.select(-1, -1);
    sender.addEventListener(sender.hostElement, 'click', (e) => {
      let ht = sender.hitTest(e);
      if (ht._p._rng._row !== -1) {
        let selectedRows = sender.cells._rows[ht.row]._data;
        if (ht.col < 12) {
          //if (ht.col > 0 && ht.col < 5) {
          // setInfoVisible(true);
          let testId = selectedRows.id;
          // Call the API and handle the response
          getAudiogramGraph(testId)
            .then((graphData) => {
              selectedRows.graphData = graphData;
              setInfoRecord(selectedRows);
            })
            .catch((error) => {
              console.error('Error in getAudiogramGraph:', error);
            });
        }
      }
    });
  };
  const getAudiogramGraph = (id) => {
    setNoGFound(true);
    return axios
      .post(settings.serverUrl + '/api/getAudiogramGraphData', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          custId: localStorage.getItem('customerId'),
          testId: id
        }
      })
      .then((response) => {
        let finalResult = response.data;
        setGraphData(finalResult);
        setNoGFound(false);
        return finalResult;
      })
      .catch((error) => {
        console.error('Error fetching audiogram graph data:', error);
        throw error;
      });
  };

  const downloadStsReport = (id) => {
    axios
      .post(settings.serverUrl + '/api/getAudiogramStsReport', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          custId: localStorage.getItem('customerId'),
          testId: id
        }
      },{
        withCredentials:true
      })
      .then((response) => {
        let finalResult = response.data;

        if (
          finalResult &&
          finalResult.length > 0 &&
          finalResult[0].url &&
          finalResult[0].url !== ''
        ) {
          window.open(finalResult[0].url);
        } else {
          if (finalResult && finalResult.length === 0) {
            notification.error({
              message: 'No Data Found!'
            });
          } else {
            notification.error({
              message: 'Empty URL in response!'
            });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          handleSessionExpired();
          return;
        }
        console.error('Error while fetching data:', error);
      });
  };

  const downloadAttachment = (id) => {
    axios
      .post(settings.serverUrl + '/api/getAudiogramAttchmentReport', {
        params: {
          email: localStorage.getItem("myData"),
          user: localStorage.getItem("myData"),
          // pass: localStorage.getItem("myPass"),
          custId: localStorage.getItem("customerId"),
          testId: id,
        },
      },{
        withCredentials:true
      })
      .then((response) => {
        // setDownloadLoadAttachName(response.data);
        setDownloadLoadAttachName(prev => [...prev, ...response.data]);

        // if (
        //   finalResult &&
        //   finalResult.length > 0 &&
        //   finalResult[0].url &&
        //   finalResult[0].url !== ""
        // ) {
        //   window.open(finalResult[0].url, "_blank");
        // } else if (finalResult.length === 0) {
        //   notification.error({ message: "No Data Found!" });
        // } else {
        //   notification.error({ message: "Empty URL in response!" });
        // }
      }).catch((error) => {
        if (error?.response?.status === 401) {
          handleSessionExpired();
          return;
        }
        console.error("Error while fetching attachment:", error);
        notification.error({ message: "Failed to fetch attachment!" });
      });
  };

     const downloadAttachmentShow=(url)=>{
         if (url && url !== "") {
            window.open(url, "_blank");
          } else if (url.length === 0) {
            notification.error({ message: "No Data Found!" });
          } else {
            notification.error({ message: "Empty URL in response!" });
          }
     }

  const downloadStsChart = (id) => {
    axios
      .post(settings.serverUrl + '/api/getAudiogramStsChartReport', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          custId: localStorage.getItem('customerId'),
          testId: id
        }
      })
      .then((response) => {
        let finalResult = response.data;

        if (
          finalResult &&
          finalResult.length > 0 &&
          finalResult[0].url &&
          finalResult[0].url !== ''
        ) {
          window.open(finalResult[0].url);
        } else {
          if (finalResult && finalResult.length === 0) {
            notification.error({
              message: 'No Data Found!'
            });
          } else {
            notification.error({
              message: 'Empty URL in response!'
            });
          }
        }
      })
      .catch((error) => {
        console.error('Error while fetching data:', error);
      });
  };
  const getAudiogramRightHisData = (id) => {
    setRightNoFound(true);
    axios
      .post(settings.serverUrl + '/api/getAudiogramRightHisDataByEmpId', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          custId: localStorage.getItem('customerId'),
          empId: id
        }
      },{
        withCredentials:true
      })
      .then((response) => {
        let finalResult = response.data;
        const uniqueIds = new Set();
        let testNameEmp = location.state.test_name;

        finalResult = response.data
          .filter((k) => {
            if (!uniqueIds.has(k.id)) {
              uniqueIds.add(k.id);
              return true;
            }
            return false;
          })
          .filter((k) => {
            return k.testname != null
            // && k.testname === testNameEmp;
          })
          .map((k) => {
            return {
              ...k,
              age: k.age != null ? k.age : '',
              testing_date: k.testing_date != null ? k.testing_date : '',
              testName: k.testname != null ? k.testname : '',
              is_first_record: k.is_first_record != null ? k.is_first_record : '',
              is_left_sts: k.is_left_sts != null ? k.is_left_sts : '',
              is_right_sts: k.is_right_sts != null ? k.is_right_sts : '',
              osha_recordable_left: k.osha_recordable_left != null ? k.osha_recordable_left : '',
              osha_recordable_right: k.osha_recordable_right != null ? k.osha_recordable_right : '',
              test_detail_id: k.test_detail_id != null && k.test_detail_id,
              testing_date_left_baseline:k.testing_date_left_baseline != null
              ? k.testing_date_left_baseline && moment(k.testing_date_left_baseline).format('MM/DD/YYYY')
              : '',
              testing_date_left_baseline:
                k.testing_date_left_baseline != null
                  ? k.testing_date_left_baseline && moment(k.testing_date_left_baseline).format('MM/DD/YYYY')
                  : '',
              is_left_baseline: k.is_left_baseline != null ? k.is_left_baseline : '',
              create_date: k.create_date != null ? moment(k.create_date).format('MM/DD/YYYY') : '',
              right_date:
                k.right_date != null
                  ? k.right_date && moment(k.right_date).format('MM/DD/YYYY')
                  : '',
              right_type: k.right_type && k.right_type,
              right_5k: k.right_5k != '' ? k.right_5k : '',
              right_1k: k.right_1k != '' ? k.right_1k : '',
              right_2k: k.right_2k != '' ? k.right_2k : '',
              right_3k: k.right_3k != '' ? k.right_3k : '',
              right_4k: k.right_4k != '' ? k.right_4k : '',
              right_6k: k.right_6k != '' ? k.right_6k : '',
              right_8k: k.right_8k != '' ? k.right_8k : '',
              right_ahl: k.right_ahl != '' ? k.right_ahl : '',
              right_sts: k.right_sts != '' ? k.right_sts : '',
              right_age_sts: k.right_age_sts != '' ? k.right_age_sts : '',
              right_osha: k.right_age_osha != '' ? k.right_age_osha : '',
              addendum_area: k.addendum_area != null ? k.addendum_area : '',
              medical_referral_left: k.medical_referral_left != null ? k.medical_referral_left : '',
              medical_referral_right:
                k.medical_referral_right != null ? k.medical_referral_right : '',
              asymmetric_right: k.asymmetric_right != null ? k.asymmetric_right : '',
              asymmetric_left: k.asymmetric_left != null ? k.asymmetric_left : '',
              audiologist_name: k.audiologist_name != null ? k.audiologist_name : '',
              abnormalLeftEar_25: k.abnormalLeftEar_25 != null ? k.abnormalLeftEar_25 : '',
              abnormalRightEar_25: k.abnormalRightEar_25 != null ? k.abnormalRightEar_25 : '',
              abnormalLeftEar: k.abnormalLeftEar != null ? k.abnormalLeftEar : '',
              abnormalRightEar: k.abnormalRightEar != null ? k.abnormalRightEar : '',
              normalRightEar: k.normalRightEar != null ? k.normalRightEar : '',
              normalLeftEar: k.normalLeftEar != null ? k.normalLeftEar : '',
              non_recordable_sts_left:
                k.non_recordable_sts_left != null ? k.non_recordable_sts_left : '',
              non_recordable_sts_right:
                k.non_recordable_sts_right != null ? k.non_recordable_sts_right : '',
              recordable_sts_right: k.recordable_sts_right != null ? k.recordable_sts_right : '',
              recordable_sts_left: (k.recordable_sts_left = null ? k.recordable_sts_left : ''),
              bright_5k: k.bright_5k != null ? k.bright_5k : '',
              bright_1k: k.bright_1k != null ? k.bright_1k : '',
              bright_2k: k.bright_2k != null ? k.bright_2k : '',
              bright_3k: k.bright_3k != null ? k.bright_3k : '',
              bright_4k: k.bright_4k != null ? k.bright_4k : '',
              bright_6k: k.bright_6k != null ? k.bright_6k : '',
              bright_8k: k.bright_8k != null ? k.bright_8k : '',
              bleft_5k: k.bleft_5k != null ? k.bleft_5k : '',
              bleft_1k: k.bleft_1k != null ? k.bleft_1k : '',
              bleft_2k: k.bleft_2k != null ? k.bleft_2k : '',
              bleft_3k: k.bleft_3k != null ? k.bleft_3k : '',
              bleft_4k: k.bleft_4k != null ? k.bleft_4k : '',
              bleft_6k: k.bleft_6k != null ? k.bleft_6k : '',
              bleft_8k: k.bleft_8k != null ? k.bleft_8k : '',
              left_5K: k.left_5k != '' ? k.left_5k : '',
              left_1K: k.left_1k != '' ? k.left_1k : '',
              left_2K: k.left_2k != '' ? k.left_2k : '',
              left_3K: k.left_3k != '' ? k.left_3k : '',
              left_4K: k.left_4k != '' ? k.left_4k : '',
              left_6K: k.left_6k != '' ? k.left_6k : '',
              left_8K: k.left_8k != '' ? k.left_8k : '',
              left_age_sts: k.left_age_sts != '' ? k.left_age_sts : '',
              left_osha: k.left_age_osha != '' ? k.left_age_osha : '',
              final_result: k.final_result != '' ? k.final_result:'',
              wre_sts_workrelated: k.wre_sts_workrelated != '' ? k.wre_sts_workrelated:'',
              wre_sts_nonworkrelated_cause : k.wre_sts_nonworkrelated_cause !='' ? k.wre_sts_nonworkrelated_cause :'',
              reasons: k.reasons != '' ? k.reasons : '',
            };
          });

         let sortedData = finalResult
        .sort((a, b) => {
          const dateA = a.testing_date ? new Date(a.testing_date) : 0;
          const dateB = b.testing_date ? new Date(b.testing_date) : 0;
          return dateB - dateA; // latest first
        })
        .map(item => ({
          ...item,
          testing_date: item.testing_date 
            ? moment(item.testing_date).format("MM/DD/YYYY") 
            : ""
        }));

        const collectionView2 = new CollectionView(sortedData, {
          pageSize: sortedData.length,
          collectionChanged: (s) => {
            filterRefCounter.current = s.totalItemCount;
            var filterCounter = document.getElementById('filterCounter');
            if (filterCounter) {
              filterCounter.textContent = s.totalItemCount;
            }
          }
        });
        setRightView(collectionView2);
        setAudiogramRightData(sortedData);
        setLeftEarResult(sortedData)
        setRightNoFound(false);
      }).catch((error) => {
                // ✅ Handle session expired
                if (error?.response?.status === 401) {
                  handleSessionExpired();
                  return;
                }
              });
  };

    const getDocPermission = () => {
  axios
    .post(settings.serverUrl + '/api/documentPermission', {
      params: {
        user: localStorage.getItem('myData'),
        docPermission:'group_appointment_register_tests_reports'
      }
    },{
      withCredentials:true
    })
    .then((response) => {
      if (response.status === 200 && response.data) {
        setDocPermission(response.data.finalStatus);
      }
    }).catch((error) => {
    // ✅ Handle session expired
    if (error?.response?.status === 401) {
      handleSessionExpired();
      return;
    }
  });
};

  const showBaseline = (item) => {
    return (
      <span>
        <input
          style={{
            appearance: 'none',
            WebkitAppearance: 'none',
            width: '12px',
            height: '12px',
            border: '1px solid gray',
            borderRadius:'3px',
            backgroundColor: 'white',
            backgroundImage:
              item.item.is_left_baseline ? `url("data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='20 6 9 17 4 12'/></svg>")` : 'none',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            cursor: 'default',
          }}
          type='checkbox'
          checked={item.item.is_left_baseline != null && item.item.is_left_baseline != false}
          disabled
        />
      </span>
    );
  };

  const showAverage = (item) => {
  const value = item.item.ahl_left;
  if (value === null || value === undefined || value === '') return '';

  const num = Number(value);
  return <span>{Number.isInteger(num) ? num : num.toFixed(1)}</span>;
};

  const showHl = (item) => {
    return (
      <span>
        <input
         style={{
            appearance: 'none',
            WebkitAppearance: 'none',
            width: '12px',
            height: '12px',
            border: '1px solid gray',
            borderRadius:'3px',
            backgroundColor: 'white',
            backgroundImage:
              item.item.left_htl ? `url("data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='20 6 9 17 4 12'/></svg>")` : 'none',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            cursor: 'default',
          }}
          type='checkbox'
          checked={item.item.left_htl != null && item.item.left_htl != false}
          disabled
        />
      </span>
    );
  };
  
  const showSts = (item) => {
    return (
      <span>
        <input
         style={{
            appearance: 'none',
            WebkitAppearance: 'none',
            width: '12px',
            height: '12px',
            border: '1px solid gray',
            borderRadius:'3px',
            backgroundColor: 'white',
            backgroundImage:
              item.item.is_left_sts ? `url("data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='20 6 9 17 4 12'/></svg>")` : 'none',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            cursor: 'default',
          }}
          type='checkbox'
          checked={item.item.is_left_sts != null && item.item.is_left_sts != false}
          disabled
        />
      </span>
    );
  };
  const showOSHA = (item) => {
    return (
      <span>
        <input
         style={{
            appearance: 'none',
            WebkitAppearance: 'none',
            width: '12px',
            height: '12px',
            border: '1px solid gray',
            borderRadius:'3px',
            backgroundColor: 'white',
            backgroundImage:
              item.item.std_osha_left ? `url("data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='20 6 9 17 4 12'/></svg>")` : 'none',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            cursor: 'default',
          }}
          type='checkbox'
          checked={item.item.std_osha_left != null && item.item.std_osha_left != false}
          disabled
        />
      </span>
    );
  };
  const showASts = (item) => {
    return (
      <span>
        <input
         style={{
            appearance: 'none',
            WebkitAppearance: 'none',
            width: '12px',
            height: '12px',
            border: '1px solid gray',
            borderRadius:'3px',
            backgroundColor: 'white',
            backgroundImage:
              item.item.age_corrected_left ? `url("data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='20 6 9 17 4 12'/></svg>")` : 'none',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            cursor: 'default',
          }}
          type='checkbox'
          checked={item.item.age_corrected_left != null && item.item.age_corrected_left != false}
          disabled
        />
      </span>
    );
  };
  const showStsAge = (item) => {
    return (
      <span>
        <input
          type='checkbox'
          checked={item.item.right_age_sts != null && item.item.right_age_sts != false}
          disabled
        />
      </span>
    );
  };
  const showAOsha = (item) => {
    return (
      <span>
        <input
         style={{
            appearance: 'none',
            WebkitAppearance: 'none',
            width: '12px',
            height: '12px',
            border: '1px solid gray',
            borderRadius:'3px',
            backgroundColor: 'white',
            backgroundImage:
              item.item.osha_recordable_left ? `url("data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='20 6 9 17 4 12'/></svg>")` : 'none',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            cursor: 'default',
          }}
          type='checkbox'
          checked={
            item.item.osha_recordable_left != null && item.item.osha_recordable_left != false
          }
          disabled
        />
      </span>
    );
  };
  const showFinalResult = (item) => {
  if (item.item.osha_recordable_left && item.item.age_corrected_left != null && item.item.age_corrected_left != false && item.item.is_left_sts != null && item.item.is_left_sts !== false) {
    if (item.item.final_result === 'CONFIRMED SHIFT') {
      return <span>Confirmed</span>;
    } else if (item.item.final_result === 'TEMPORARY SHIFT') {
      return <span>Temporary</span>;
    } else if(item.item.final_result === 'NON-RECORDABLE'){
      return <span>NON-RECORDABLE</span>;
    }
  }
  return null;
};
    const showStsWorkRelated = (item) => {
      const workRelated = item?.item?.wre_sts_workrelated;
      if (item.item.osha_recordable_left && item.item.age_corrected_left && item.item.wre_sts_workrelated) {
        if (workRelated) {
      return <p>{workRelated}</p>;
     }
      }
      return null;
    };

  const showStsNonWorkRelatedCause = (item) => {
  if (item.item.osha_recordable_left && item.item.age_corrected_left != null && item.item.age_corrected_left != false && item.item.wre_sts_nonworkrelated_cause  != null && item.item.wre_sts_nonworkrelated_cause  !== false) {
    const causeMap = {
      age_related: 'Age-Related Hearing Loss',
      medical_condition: 'Non-Occupational Medical Condition',
      noise_exposure: 'Non-Occupational Noise Exposure',
      ototoxic_medication: 'Non-Occupational Ototoxic Medication or Chemical',
      trauma_injury: 'Non-Occupational Trauma or Injury',
      other: 'Other (Non-Occupational)',
    };

    const fullText = causeMap[item.item.wre_sts_nonworkrelated_cause ] || '';
    if (!fullText) return null;
    const shortText = fullText.split(' ').slice(0, 2).join(' ');
    return <span title={fullText}>{shortText}...</span>;
  }
  return null;
};
const showSTSReport = (item) => {
  return (
    <>
      {(docPermission && item.item.testName == 'Audiogram' && item.item.age_corrected_left && item.item.sts_pdf) && (
        <FilePdfTwoTone
          twoToneColor='#FF0000'
          style={{ fontSize: '16px', cursor: 'pointer', marginLeft: '10px' }}
          onClick={() => downloadStsReport(item.item.id)}
        />
      )}
    </>
  );
};
    const showAttachment = (item) => {
      return (
        <>
          {item.item.testName === 'Audiogram' 
          && (item.item.audiogram_attachment_found 
          || (item.item.sts_attachment_found && item.item.age_corrected_left != null && item.item.age_corrected_left != false)
          || (item.item.age_corrected_left != null && item.item.age_corrected_left != false && item.item.wre_attachment_found)) && (
          <FolderOpenTwoTone
          twoToneColor='#cc7a00'
          style={{ fontSize: '16px', cursor: 'pointer', marginLeft: '10px' }}
            onClick={() => {
            setDownloadLoadAttachName([])
            if (item.item.audiogram_attachment_found) {
              downloadAttachment(item.item.id);
              }
              if (item.item.sts_attachment_found && item.item.age_corrected_left != null && item.item.age_corrected_left != false) {
                downloadAttachment(item.item.sts_id);
              }
              if (item.item.age_corrected_left != null && item.item.age_corrected_left != false && item.item.wre_attachment_found) {
                downloadAttachment(item.item.wre_id);
              }
            setSelectedDocItem(item.item);
            setIsModalVisible(true);
          }}
        />
          )}
        </>
      );
    };
  return (
    <div style={{ padding: '0px 30px' }}>
    <Modal
    width={600}
    title="Document Details"
    visible={isModalVisible}
    onCancel={() => setIsModalVisible(false)}
    footer={null}
    >
      {downloadLoadAttachName.length === 0 ? (
        <div style={{display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
          <Spin size="large" />
        </div>
      ) : (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    <thead>
      <tr style={{ borderBottom: '1px solid #ccc' }}>
        <th style={{ textAlign: 'left', padding: '8px' }}>Document Name</th>
        <th style={{ textAlign: 'left', padding: '8px' }}>Action</th>
      </tr>
    </thead>
<tbody>
  {downloadLoadAttachName.map((val, index) => (
    <tr key={index}>
      <td style={{ padding: '8px' }}>{val.name}</td>
      <td style={{ padding: '8px' }}>
        <FilePdfTwoTone
          twoToneColor="#FF0000"
          style={{ fontSize: '16px', cursor: 'pointer', marginLeft: '10px' }}
          onClick={() => downloadAttachmentShow(val.url)}
        />
      </td>
    </tr>
  ))}
</tbody>
    </table>
    )}
    </Modal>
      {!rightNofound ? (
        audiogramRightData.length > 0 ? (
          <>
            <FlexGrid
              ref={theGrid}
              id='theGridTallRows'
              className='audiogramLeft cliniclisttable'
              itemsSource={rightView}
              initialized={gridInitialized}
              //itemsPerPage={10}
              isReadOnly={true}
              style={{ height: 'auto',width:'100%', overflowX: 'auto' }}
            >
              <FlexGridColumn binding='testing_date' header='Test Date' width={90} />
              <FlexGridColumn binding='reasons' header='Reason' width={150} />
              <FlexGridColumn binding='is_left_baseline' header='Baseline' width={80}>
                <FlexGridCellTemplate cellType='Cell' template={showBaseline} />
              </FlexGridColumn>
              <FlexGridColumn binding='testing_date_left_baseline' header='BDate' width={80}></FlexGridColumn>
              <FlexGridColumn binding='age' header='Age' width={60}></FlexGridColumn>
              <FlexGridColumn
                binding='left_5k'
                header='500'
                width={60}
                wordWrap={true}
              ></FlexGridColumn>
              <FlexGridColumn binding='left_1k' header='1000' width={60} wordWrap={true} />
              <FlexGridColumn binding='left_2k' header='2000' width={60} />
              <FlexGridColumn binding='left_3k' header='3000' width={60} />
              <FlexGridColumn binding='left_4k' header='4000' width={60} />
              <FlexGridColumn binding='left_6k' header='6000' width={60} />
              <FlexGridColumn binding='left_8k' header='8000' width={60} />
               <FlexGridColumn binding='ahl_left' header='AVG' width={60}>
              <FlexGridCellTemplate cellType='Cell' template={showAverage} />
              </FlexGridColumn>
              <FlexGridColumn binding='sts_left' header='STS' width={60} />
              <FlexGridColumn binding='sts_agcleft' header='aSTS' width={60} />
              <FlexGridColumn binding='left_htl' header='HL' width={60}>
                <FlexGridCellTemplate cellType='Cell' template={showHl} />
              </FlexGridColumn>
              <FlexGridColumn binding='is_left_sts' header='STS' width={60}>
                <FlexGridCellTemplate cellType='Cell' template={showSts} />
              </FlexGridColumn>
              <FlexGridColumn binding='std_osha_left' header='OSHA' width={65}>
                <FlexGridCellTemplate cellType='Cell' template={showOSHA} />
              </FlexGridColumn>
              <FlexGridColumn binding='age_corrected_left' header='aSTS' width={60}>
                <FlexGridCellTemplate cellType='Cell' template={showASts} />
              </FlexGridColumn>
              <FlexGridColumn binding='osha_recordable_left' header='aOSHA' width={72}>
                <FlexGridCellTemplate cellType='Cell' template={showAOsha} />
              </FlexGridColumn>
               <FlexGridColumn binding='id' header='STS Report' width={90}>
                <FlexGridCellTemplate cellType='Cell' template={showSTSReport} />
                </FlexGridColumn>
                <FlexGridColumn binding="final_result" header="Shift" width={130}>
                <FlexGridCellTemplate cellType="Cell" template={showFinalResult} />
                </FlexGridColumn>
                <FlexGridColumn binding="wre_sts_workrelated" header="STS Work-Related" width={130}>
                <FlexGridCellTemplate cellType="Cell" template={showStsWorkRelated} />
                </FlexGridColumn>
                <FlexGridColumn binding="wre_sts_nonworkrelated_cause" header="STS Non-Work-Related Cause" width={200}>
                <FlexGridCellTemplate cellType="Cell" template={showStsNonWorkRelatedCause} />
                </FlexGridColumn>
                 <FlexGridColumn binding='id' header='Attachment' width={90}>
                <FlexGridCellTemplate cellType='Cell' template={showAttachment}/>
                </FlexGridColumn>
              <FlexGridFilter
                showFilterIcons={true}
                placeholder='Filter data...'
                defaultFilterType='Value'
                filterColumns={[
                  'testing_date',
                  'is_left_baseline',
                  'age',
                  'left_5k',
                  'left_1k',
                  'left_2k',
                  'left_3k',
                  'left_4k',
                  'left_6k',
                  'left_8k',
                  'is_left_sts',
                  'osha_recordable_left',
                  'testing_date_left_baseline',
                  'ahl_left',
                  'sts_left',
                  'sts_agcleft',
                  'left_htl',
                  'std_osha_left',
                  'age_corrected_left',
                  'final_result',
                  'reasons',
                  'wre_sts_nonworkrelated_cause',
                  'wre_sts_workrelated'
                ]}
              />
            </FlexGrid>
            <Modal
              width={1200}
              centered
              zIndex={1000}
              title={<p>{`Test detail for ${infoRecord.testing_date}`}</p>}
              visible={infoVisible}
              onOk={() => setInfoVisible(false)}
              onCancel={() => setInfoVisible(false)}
              footer={null}
            >
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
               <div>
                <span
                  style={{
                    color: 'rgb(60,107,246)',
                  }}
                >
                  <p>Left Ear Results:</p>
                </span>

                <table className='rightearresult' style={{ width: 'auto',marginBottom:20 }}>
                  <thead style={{ backgroundColor: 'rgb(60,107,246)', color: 'white' }}>
                    <tr>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'100px',fontSize:'11px' }}>
                        Frequency (Hz)
                      </th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>500</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>1000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>2000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>3000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>4000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>6000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>8000</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          color: 'rgb(60,107,246)',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        Air (dB HL)
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.left_5K}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.left_1K}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.left_2K}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.left_3K}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.left_4K}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.left_6K}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.left_8K}
                      </td>
                    </tr>
                    {infoRecord.testName == 'STS Report' && (
                      <tr>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          Baseline
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bleft_5k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bleft_1k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bleft_2k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bleft_3k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bleft_4k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bleft_6k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bleft_8k}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {infoRecord.testName == 'STS Report' && (
                  <p>
                    Established Baseline(
                    {infoRecord.testing_date_left_baseline})
                  </p>
                )}
              </div>
              <div>             
                {/* {(infoRecord.testName == 'STS Report' || infoRecord.is_left_sts || infoRecord.is_right_sts) && (
                  <div style={{ display: 'flex', direction: 'rtl' }}>
                    <Button
                      size='small'
                      style={{
                        backgroundColor: 'rgb(61 88 106)',
                        color: 'white',
                        marginTop: 0,
                        padding: 10,
                        marginRight: 5
                      }}
                      onClick={() => downloadStsChart(infoRecord.id)}
                      icon={<DownloadOutlined />}
                    >
                      STS Chart Report
                    </Button>
                    <Button
                      size='small'
                      style={{
                        backgroundColor: 'rgb(61 88 106)',
                        color: 'white',
                        marginTop: 0,
                        padding: 10,
                        marginRight: 5
                      }}
                      onClick={() => downloadStsReport(infoRecord.id)}
                      icon={<DownloadOutlined />}
                    >
                      STS Report
                    </Button>
                  </div>
                )} */}
                <span
                  style={{
                    color: 'rgb(195, 95, 78)',
                   
                  }}
                >
                  <p>Right Ear Results:</p>
                </span>
                <table className='rightearresult' style={{ width: 'auto', margin:0 }}>
                  <thead style={{ backgroundColor: 'rgb(195,95,78)', color: 'white' }}>
                    <tr>
                      <th style={{ textAlign: 'center', border: '1px solid grey',fontSize:'11px',width:'100px' }}>
                        Frequency (Hz)
                      </th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>500</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>1000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>2000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>3000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>4000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>6000</th>
                      <th style={{ textAlign: 'center', border: '1px solid grey',width:'60px',fontSize:'11px' }}>8000</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          color: 'rgb(195,95,78)',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        Air (dB HL)
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.right_5k}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.right_1k}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.right_2k}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.right_3k}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.right_4k}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.right_6k}
                      </td>
                      <td
                        style={{
                          border: '1px solid grey',
                          textAlign: 'center',
                          fontWeight: 'bold'
                          ,fontSize:'11px'
                        }}
                      >
                        {infoRecord.right_8k}
                      </td>
                    </tr>
                    {infoRecord.testName == 'STS Report' && (
                      <tr>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          Baseline
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bright_5k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bright_1k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bright_2k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bright_3k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bright_4k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bright_6k}
                        </td>
                        <td
                          style={{
                            border: '1px solid grey',
                            textAlign: 'center',
                            fontWeight: 'bold'
                          }}
                        >
                          {infoRecord.bright_8k}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {infoRecord.testName == 'STS Report' && (
                  <p>
                    Established Baseline(
                    {infoRecord.testing_date_left_baseline})
                  </p>
                )}
                </div>              
              </div>
              <br />
              <div>
                {!noGfound ? (
                  infoRecord?.graphData?.length > 0 ? (
                    <div
                      style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}
                    >
                      <div
                        style={{
                          position: 'relative',
                          maxWidth: '50%',
                          flex: '0 0 50%',
                          marginBottom: '20px'
                        }}
                      >
                        {/* <span
                          style={{
                            position: 'absolute',
                            top: '5px',
                            left: '5px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: 'rgb(60,107,246)',
                            padding: '5px',
                            borderRadius: '5px'
                          }}
                        >
                          Left Ear Graph:
                        </span> */}
                             <Plot
                          data={[
                            {
                              x: [500, 1000, 2000, 3000, 4000, 6000, 8000],
                              y: [
                                latestLeftEarRecord?.left_5k,
                                latestLeftEarRecord?.left_1k,
                                latestLeftEarRecord?.left_2k,
                                latestLeftEarRecord?.left_3k,
                                latestLeftEarRecord?.left_4k,
                                latestLeftEarRecord?.left_6k,
                                latestLeftEarRecord?.left_8k,
                              ],
                              type: 'scatter',
                              mode: 'lines+markers',
                              name: 'Right Air',
                              marker: { symbol: 'x', size: 11, color: 'blue' },
                              line: { color: 'blue', width: 2 },
                            },
                            {
                              x: [500, 1000, 2000, 3000, 4000, 6000, 8000],
                              y: [
                                latestLeftBaslineRecord?.left_5k,
                                latestLeftBaslineRecord?.left_1k,
                                latestLeftBaslineRecord?.left_2k,
                                latestLeftBaslineRecord?.left_3k,
                                latestLeftBaslineRecord?.left_4k,
                                latestLeftBaslineRecord?.left_6k,
                                latestLeftBaslineRecord?.left_8k,
                              ],
                              type: 'scatter',
                              mode: 'lines+markers',
                              name: 'Right Bone',
                              marker: { symbol: 'circle', size: 8, color: 'black' },
                              line: { color: 'black', width: 2 },
                            },
                          ]}
                          layout={{
                            title: {
                              font: { size: 16, color: 'blue' },
                              x: 0,
                            },
                            showlegend: false,
                            height: 400,
                            width:550,
                             margin: {
                                l: 40,
                                r: 10,
                                t: 40,
                                b: 5,
                              },
                                legend: {
                                orientation: 'h',
                                x: 0.1,
                                y: 0,
                                xanchor: 'left',
                                yanchor: 'top',
                              },
                            plot_bgcolor: 'white',
                            paper_bgcolor: 'white',
                            xaxis: {
                              title: 'Frequency (Hz)',
                              tickvals: [500, 1000, 2000, 3000, 4000, 6000, 8000],
                              ticktext: ['500', '1000', '2000', '3000', '4000', '6000', '8000'],
                              showgrid: true,
                              gridcolor: 'rgb(139, 137, 137)',
                              linecolor: '#4B4B4B	',
                              linewidth: 1,
                              mirror: true,
                              side: 'top', // ✅ Move X-axis to top
                              tickfont: {
                            size: 11,
                            color: '#000',
                            weight: 'bold'
                          }
                            },
                            yaxis: {
                              title: 'Loudness (dB HL)',
                              autorange: 'reversed',
                              tickvals: [-10, 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130],
                              range: [-15, 130],
                              showgrid: true,
                              gridcolor: 'rgb(139, 137, 137)',
                              linecolor: '#4B4B4B	',
                              linewidth: 1,
                              mirror: true,
                              tickfont: {
                            size: 11,
                            color: '#000',
                            weight: 'bold'
                          }
                            },
                            shapes: [
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: -10,
                                y1: 25,
                                fillcolor: '#fff', // Normal
                                opacity: 0.5,
                                line: { width: 0 },
                              },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 25,
                                y1: 40,
                                fillcolor: 'rgb(106, 176, 113)', // Mild
                                opacity: 0.6,
                                line: { width: 0},
                              },
                               {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 25,
                            y1: 25,
                            line: {
                              color: 'rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 40,
                                y1: 55,
                                fillcolor: 'rgb(179, 215, 127)', // Moderate
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                               {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 40,
                            y1: 40,
                            line: {
                              color: 'rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 55,
                                y1: 70,
                                fillcolor: 'rgb(248, 216, 109)', // Moderately Severe
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                               {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 55,
                            y1: 55,
                            line: {
                              color: 'rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 70,
                                y1: 90,
                                fillcolor: 'rgb(224, 149, 114)', // Severe
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                               {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 70,
                            y1: 70,
                            line: {
                              color: 'rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 90,
                                y1: 130,
                                fillcolor: 'rgb(241, 77, 71)', // Profound
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                               {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 90,
                            y1: 90,
                            line: {
                              color: 'rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 130,
                                y1: 135,
                                fillcolor: '#fff',
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                               {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 130,
                            y1: 130,
                            line: {
                              color: ' rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                            ],
                            annotations: [
                              { xref: 'paper', x: 0.02, y: 10, text: 'NORMAL', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 30, text: 'MILD', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 45, text: 'MODERATE', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 62, text: 'MODERATELY SEVERE', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 80, text: 'SEVERE', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 110, text: 'PROFOUND', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                            ],
                            legend: {
                              orientation: 'h',
                              x: 0.2,
                              y: 0,
                            },
                          }}
                        config={{ responsive: true, displaylogo: false, displayModeBar: false, useResizeHandler: true, dragmode: false, staticPlot: true, scrollZoom: false, doubleClick: false }}

                        />
                        {/* <img
                          src={infoRecord.graphData.find((item) => item.name.includes('left')).url}
                          alt='Left Ear Graph'
                          style={{ width: '100%', height: 'auto', marginRight: 10 }}
                        /> */}
                       
                        <table
                          style={{
                            width: '100%',
                            margin: '0px 0px 0px -35px',
                            textAlign: 'center'
                          }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ textAlign: 'right',fontSize:'12px' }}>Right &nbsp;&nbsp;</td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={LeftAirUp}
                                  alt='Left Air'
                                  style={{ height: '12px', width: '12px' }}
                                />
                                &nbsp;&nbsp;<span style={{fontSize:'12px'}}>Air</span>
                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={LeftMaskedAirUp}
                                  alt='Left Bone'
                                  style={{ height: '14px', width: '14px' }}
                                />
                                &nbsp;&nbsp;<span style={{fontSize:'12px'}}>Masked Air</span>
                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={LeftBoneUp}
                                  alt='Left Bone'
                                  style={{ height: '12px', width: '10px' }}
                                />
                                &nbsp;&nbsp;<span style={{fontSize:'12px'}}>Bone</span>
                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={LeftMaskedBoneUp}
                                  alt='Left Bone'
                                  style={{ height: '12px', width: '8px' }}
                                />
                                &nbsp;&nbsp;<span style={{fontSize:'12px'}}>Masked Bone</span>
                              </td>
                            </tr>
                            <tr>
                              <td style={{ textAlign: 'right',fontSize:'12px' }}>No Response&nbsp;&nbsp;</td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={LeftAirDown}
                                  alt='Left Air'
                                  style={{ height: '15px', width: '15px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Air</span>

                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={LeftMaskedAirDown}
                                  alt='Left Bone'
                                  style={{ height: '15px', width: '15px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Masked Air</span>
                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={LeftBone}
                                  alt='Left Bone'
                                  style={{ height: '25px', width: '20px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Bone</span>
                              </td>

                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={LeftMaskedBoneDown}
                                  alt='Left Bone'
                                  style={{ height: '15px', width: '15px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Masked Bone</span>
                              </td>
                            </tr>
                            <tr>
                              <td colspan={2}>
                                <img
                                  src={LeftCurrent}
                                  alt='Left Bone'
                                  style={{ height: '8px', width: '40px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Current</span>

                              </td>
                              <td></td>
                              <td colspan={2}>
                                <img
                                  src={BaselineEstab}
                                  alt='Left Bone'
                                  style={{ height: '8px', width: '40px' }}
                                />
                                &nbsp; <span style={{fontSize:'12px'}}>Established Baseline ({infoRecord.testing_date_left_baseline})</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        style={{
                          position: 'relative',
                          maxWidth: '50%',
                          flex: '0 0 50%',
                          marginBottom: '20px'
                        }}
                      >
                        {/* <span
                          style={{
                            position: 'absolute',
                            top: '5px',
                            left: '5px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: 'rgb(195,95,78)',
                            padding: '5px',
                            borderRadius: '5px'
                          }}
                        >
                          Right Ear Graph:
                        </span> */}
                        <Plot
                          data={[
                            {
                              x: [500, 1000, 2000, 3000, 4000, 6000, 8000],
                              y: [
                                latestRightEarRecord?.right_5k,
                                latestRightEarRecord?.right_1k,
                                latestRightEarRecord?.right_2k,
                                latestRightEarRecord?.right_3k,
                                latestRightEarRecord?.right_4k,
                                latestRightEarRecord?.right_6k,
                                latestRightEarRecord?.right_8k,
                              ],
                              type: 'scatter',
                              mode: 'lines+markers',
                              name: 'Right Air',
                              // marker: { symbol: 'circle', size: 16, color: 'red' },
                              marker: {
                                size: 12,
                                color: 'rgba(0,0,0,0)', 
                                line: {
                                  color: 'red', 
                                  width: 2
                                },
                                symbol: 'circle'
                              },
                              line: { color: 'red', width: 2 },
                            },
                            {
                              x: [500, 1000, 2000, 3000, 4000, 6000, 8000],
                              y: [
                                latestRightBaslineRecord?.right_5k,
                                latestRightBaslineRecord?.right_1k,
                                latestRightBaslineRecord?.right_2k,
                                latestRightBaslineRecord?.right_3k,
                                latestRightBaslineRecord?.right_4k,
                                latestRightBaslineRecord?.right_6k,
                                latestRightBaslineRecord?.right_8k,
                              ],
                              type: 'scatter',
                              mode: 'lines+markers',
                              name: 'Right Bone',
                              marker: { symbol: 'circle', size: 10, color: 'black' },
                              line: { color: 'black', width: 2 },
                            },
                          ]}
                          layout={{
                            title: {
                              font: { size: 16, color: 'brown' },
                              x: 0,
                            },
                            showlegend: false,
                            height: 400,
                            width:550,
                             margin: {
                                l: 40,
                                r: 10,
                                t: 40,
                                b: 5,
                              },
                                legend: {
                                orientation: 'h',
                                x: 0.1,
                                y: 0,
                                xanchor: 'left',
                                yanchor: 'top',
                              },
                            plot_bgcolor: 'white',
                            paper_bgcolor: 'white',
                            xaxis: {
                              title: 'Frequency (Hz)',
                              tickvals: [500, 1000, 2000, 3000, 4000, 6000, 8000],
                              ticktext: ['500', '1000', '2000', '3000', '4000', '6000', '8000'],
                              showgrid: true,
                              gridcolor: 'rgb(139, 137, 137)',
                              linecolor: '#4B4B4B',
                              linewidth: 1,
                              mirror: true,
                              side: 'top',
                              tickfont: {
                            size: 11,
                            color: '#000',
                            weight: 'bold'
                          }
                            },
                            yaxis: {
                              title: 'Loudness (dB HL)',
                              autorange: 'reversed',
                              tickvals: [-10, 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130],
                              range: [-10, 130],
                              showgrid: true,
                              gridcolor: 'rgb(139, 137, 137)',
                              linecolor: '#4B4B4B',
                              linewidth: 1,
                              mirror: true,
                              tickfont: {
                            size: 11,
                            color: '#000',
                            weight: 'bold'
                          }
                            },
                            shapes: [
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: -10,
                                y1: 25,
                                fillcolor: '#fff', // Normal
                                opacity: 0.5,
                                line: { width: 0 },
                              },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 25,
                                y1: 40,
                                fillcolor: 'rgb(106, 176, 113)', // Mild
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                              {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 25,
                            y1: 25,
                            line: {
                              color: ' rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 40,
                                y1: 55,
                                fillcolor: 'rgb(179, 215, 127)', // Moderate
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                              {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 40,
                            y1: 40,
                            line: {
                              color: ' rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 55,
                                y1: 70,
                                fillcolor: 'rgb(248, 216, 109)' , // Moderately Severe
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                              {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 55,
                            y1: 55,
                            line: {
                              color: ' rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 70,
                                y1: 90,
                                fillcolor: 'rgb(224, 149, 114)', // Severe
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                              {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 70,
                            y1: 70,
                            line: {
                              color: ' rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 90,
                                y1: 130,
                                fillcolor: 'rgb(241, 77, 71)', // Profound
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                              {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 90,
                            y1: 90,
                            line: {
                              color: ' rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                              {
                                type: 'rect',
                                xref: 'paper',
                                x0: 0,
                                x1: 1,
                                yref: 'y',
                                y0: 130,
                                y1: 135,
                                fillcolor: '#fff',
                                opacity: 0.6,
                                line: { width: 0 },
                              },
                              {
                            type: 'line',
                            xref: 'paper',
                            x0: 0,
                            x1: 1,
                            yref: 'y',
                            y0: 130,
                            y1: 130,
                            line: {
                              color: ' rgb(75, 74, 74)',
                              width: 1
                            }
                          },
                            ],
                            annotations: [
                              { xref: 'paper', x: 0.02, y: 10, text: 'NORMAL', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 30, text: 'MILD', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 45, text: 'MODERATE', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 62, text: 'MODERATELY SEVERE', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 80, text: 'SEVERE', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                              { xref: 'paper', x: 0.02, y: 110, text: 'PROFOUND', showarrow: false, align: 'right',font: {
                              size: 10,
                              color: 'black',
                            }, },
                            ],
                            legend: {
                              orientation: 'h',
                              x: 0.2,
                              y: 0,
                            },
                          }}
                        config={{ responsive: true, displaylogo: false, displayModeBar: false, useResizeHandler: true, dragmode: false, staticPlot: true, scrollZoom: false, doubleClick: false }}

                        />
                        {/* <img
                          src={infoRecord.graphData.find((item) => item.name.includes('right')).url}
                          alt='Right Ear Graph'
                          style={{ width: '100%', height: 'auto', marginRight: 10 }}
                        /> */}
                        <table
                          style={{
                            width: '100%',
                            margin: '0px 0px 0px -35px',
                            textAlign: 'center'
                          }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ textAlign: 'right',fontSize:'12px' }}>Right &nbsp;&nbsp;</td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={RightAir}
                                  alt='Right Air'
                                  style={{ height: '12px', width: '12px' }}
                                />
                                &nbsp;&nbsp;<span style={{fontSize:'12px'}}>Air</span>
                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={RightMaskedAirUp}
                                  alt='Right Air'
                                  style={{ height: '12px', width: '12px' }}
                                />
                                &nbsp;&nbsp;<span style={{fontSize:'12px'}}>Masked Air</span>
                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={RightBoneUp}
                                  alt='Right Air'
                                  style={{ height: '12px', width: '12px' }}
                                />
                                &nbsp;&nbsp;<span style={{fontSize:'12px'}}>Bone</span>
                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={RightMaskedBoneUp}
                                  alt='Right Air'
                                  style={{ height: '12px', width: '12px' }}
                                />
                                &nbsp;&nbsp;<span style={{fontSize:'12px'}}>Masked Bone</span>
                              </td>
                            </tr>
                            <tr>
                              <td style={{ textAlign: 'right',fontSize:'12px' }}>No Response&nbsp;&nbsp;</td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={RightAirDown}
                                  alt='Right Air'
                                  style={{ height: '15px', width: '15px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Air</span>

                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={RightMaskedAirDown}
                                  alt='Right Air'
                                  style={{ height: '15px', width: '15px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Masked Air</span>
                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={RightBoneDown}
                                  alt='Right Air'
                                  style={{ height: '25px', width: '20px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Bone</span>

                              </td>
                              <td style={{ textAlign: 'center', border: '1px solid lightgrey' }}>
                                <img
                                  src={RightMaskedBoneDown}
                                  alt='Right Air'
                                  style={{ height: '15px', width: '15px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Masked Bone</span>
                              </td>
                            </tr>
                            <tr>
                              <td colspan={2}>
                                <img
                                  src={RightCurrent}
                                  alt='Right Air'
                                  style={{ height: '8px', width: '40px' }}
                                />
                                &nbsp;<span style={{fontSize:'12px'}}>Current</span>

                              </td>
                              <td></td>
                              <td colspan={2}>
                                <img
                                  src={BaselineEstab}
                                  alt='Right Air'
                                  style={{ height: '8px', width: '40px' }}
                                />
                                &nbsp; <span style={{fontSize:'12px'}}>Established Baseline ({infoRecord.testing_date_left_baseline})</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <h5 style={{ color: '#ef6727', textAlign: 'center' }}>No Graphs Available !</h5>
                  )
                ) : (
                  <Row>
                    <Col span={10}></Col>
                    <Col span={4}>
                      <Space size='middle' style={{ marginTop: 15, marginLeft:85 }}>
                        <Spin size='large' />
                      </Space>
                    </Col>
                    <Col span={10}></Col>
                  </Row>
                )}
              </div>
            </Modal>
          </>
        ) : (
          <h5 style={{ color: '#ef6727', textAlign: 'center' }}>No Record Found !</h5>
        )
      ) : (
        <Row>
          <Col span={10}></Col>
          <Col span={8}>
            <Space size='middle' style={{ marginTop: 15, marginLeft: 85 }}>
              <Spin size='large' />
            </Space>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default LeftEarTestForm;
